import React from "react";
import { useLocation } from "react-router-dom";
import { CheckIcon } from "../../icons";
import { WIZARD_STEPS, WIZARD_ROUTES } from "../../constants";
import "./WizardProgressHeader.scss";

function WizardProgressHeader() {
  const location = useLocation();
  const path = location.pathname;
  const isWizard = WIZARD_ROUTES.includes(path);
  const activeIndex = WIZARD_STEPS.findIndex((s) => s.route === path);

  // Only render on wizard flow pages
  if (!isWizard) return null;

  return (
    <div className="wph" role="navigation" aria-label="Job creation progress">
      <div className="wph__inner">
        {WIZARD_STEPS.map((step, i) => {
          const isDone = i < activeIndex;
          const isActive = i === activeIndex;
          const isPending = i > activeIndex;

          const stepClass = [
            "wph__step",
            isActive ? "wph__step--active" : "",
            isDone ? "wph__step--done" : "",
            isPending ? "wph__step--pending" : "",
          ]
            .filter(Boolean)
            .join(" ");

          const connectorClass = ["wph__connector", isDone ? "wph__connector--done" : ""]
            .filter(Boolean)
            .join(" ");

          return (
            <React.Fragment key={step.key}>
              {/* Connector line between steps */}
              {i > 0 && <div className={connectorClass} aria-hidden="true" />}

              {/* Step */}
              <div
                className={stepClass}
                aria-current={isActive ? "step" : undefined}
                aria-label={`Step ${i + 1}: ${step.label} — ${
                  isDone ? "completed" : isActive ? "current" : "not started"
                }`}
              >
                {/* Bubble */}
                <div className="wph__bubble">{isDone ? <CheckIcon /> : <span>{i + 1}</span>}</div>

                {/* Label */}
                <span className="wph__label">{step.label}</span>
              </div>
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}

export default WizardProgressHeader;
